// Getters
export const LEAD = 'landing_page/LEAD'

// Mutations
export const MUTATE_LEAD = 'landing_page/MUTATE_LEAD'

// Actions
export const SAVE_LEAD = 'landing_page/SAVE_LEAD'
export const GET_CAMPAIGN_FROM_ALIAS = 'landing_page/GET_CAMPAIGN_FROM_ALIAS'
